var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('common-header',{attrs:{"companyLogo":_vm.companyLogo,"isSidebarOpen":_vm.isSidebarOpen,"company":_vm.company,"permissions":{
      isUsePurchase: _vm.isUsePurchase,
      isUseInventory: _vm.isUseInventory,
      isUseSmallLot: _vm.isUseSmallLot,
      isAdminAndAbove: _vm.isAdminAndAbove,
      isMasterAdminAndAbove: _vm.isMasterAdminAndAbove,
    },"serviceID":_vm.serviceID,"existLocationHistory":_vm.existLocationHistory},on:{"toggleSidebar":_vm.toggleSidebar,"saveServiceID":_vm.saveServiceID}}),_c('div',{staticClass:"contents-wrapper"},[_c('common-sidebar',{attrs:{"isOpen":_vm.isSidebarOpen,"permissions":{
        isUsePurchase: _vm.isUsePurchase,
        isUseInventory: _vm.isUseInventory,
        isUseSmallLot: _vm.isUseSmallLot,
        isAdminAndAbove: _vm.isAdminAndAbove,
        isMasterAdminAndAbove: _vm.isMasterAdminAndAbove,
        isUseEDI: _vm.isUseEDI,
      }},on:{"saveServiceID":_vm.saveServiceID}}),_c('div',{staticClass:"main-wrapper"},[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }